import { render } from "./selectFile.vue?vue&type=template&id=83b41808&scoped=true&ts=true"
import script from "./selectFile.vue?vue&type=script&lang=ts"
export * from "./selectFile.vue?vue&type=script&lang=ts"

import "./selectFile.vue?vue&type=style&index=0&id=83b41808&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-83b41808"]])

export default __exports__